module.exports = __webpack_public_path__ + "img/icn_reloj.24fa7012.svg";